// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"~views/colors.css\"","easilGrayDark":"#7A7D81","scrollFold":"style_scrollFold__3AnUR","scrollFoldContent":"style_scrollFoldContent__fctGb","fold":"style_fold__1Z89q"};